import { BehaviorSubject } from 'rxjs';

export const searchBoxOffset$ = new BehaviorSubject({});

export const searchBoxOffset = searchBoxOffset$.asObservable();